// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { useCart } from "../../context/CartContext";
// import productAPI from "../../api/productApi";
// import Breadcrump from "../../components/Breadcrump";
// import SEO from "../../components/SEO";
// import Auth from "../../utils/AuthUtils";
// import wishlistAPI from "../../api/wishlistApi";
// import { showError } from "../../utils/toastUtils";
// import CartOffCanvas from "../../components/CartOffCanvas";
// import { normalizeProduct } from "../../utils/normalizeProduct";

// gsap.registerPlugin(ScrollTrigger);

// // ─── Static Review Data (no reviews API available) ────────────────────────────
// const REVIEWS = [
//   {
//     id: 1,
//     name: "Priya Sharma",
//     rating: 5,
//     date: "March 2025",
//     text: "Beautiful craftsmanship and luxurious fabric. The detailing is exceptional — every stitch feels intentional and masterful.",
//     verified: true,
//   },
//   {
//     id: 2,
//     name: "Ananya Mehta",
//     rating: 5,
//     date: "February 2025",
//     text: "Wore this to a festive celebration and received countless compliments. The silk drape is absolutely divine.",
//     verified: true,
//   },
//   {
//     id: 3,
//     name: "Kavya Nair",
//     rating: 4,
//     date: "January 2025",
//     text: "Exquisite quality and the packaging was equally luxurious. True heirloom-worthy piece.",
//     verified: true,
//   },
// ];

// // ─── Star Rating Component ─────────────────────────────────────────────────────
// const StarRating = ({ value = 5, max = 5, interactive = false, onChange }) => (
//   <span className="d-inline-flex gap-1">
//     {Array.from({ length: max }).map((_, i) => (
//       <span
//         key={i}
//         onClick={() => interactive && onChange && onChange(i + 1)}
//         style={{
//           cursor: interactive ? "pointer" : "default",
//           color: i < value ? "var(--color-accent-main)" : "var(--color-border)",
//           fontSize: interactive ? "1.4rem" : "1rem",
//           lineHeight: 1,
//         }}
//       >
//         ★
//       </span>
//     ))}
//   </span>
// );

// // ─── Related Product Card (Products.jsx UI — handles both raw & normalized API data) ──
// // const RelatedCard = ({ product }) => {
// //   const cardRef = useRef(null);
// //   if (!product) return null;

// //   // Support both raw API shape and normalizeProduct shape
// //   const img = product.image || product.thumbnail || "/placeholder.jpg";
// //   const name = product.name || product.title || "";
// //   const badge = product.badge || null;
// //   const catLabel = product.craft || product.category || product.brand || "";
// //   const priceVal = product.price
// //     ? `₹${Number(product.price).toLocaleString("en-IN")}`
// //     : "";
// //   const linkSlug = product.slug || product._id || "#";

// //   return (
// //     <div
// //       ref={cardRef}
// //       className="vanya-product-card"
// //       onMouseEnter={() =>
// //         gsap.to(cardRef.current, { y: -6, duration: 0.3, ease: "power2.out" })
// //       }
// //       onMouseLeave={() =>
// //         gsap.to(cardRef.current, { y: 0, duration: 0.3, ease: "power2.out" })
// //       }
// //     >
// //       <div className="vanya-card-img-wrap">
// //         <img src={img} alt={name} className="vanya-card-img" />
// //         {badge && <span className="vanya-card-badge">{badge}</span>}
// //         <div className="vanya-card-overlay">
// //           <Link to={`/shop/${linkSlug}`} className="vanya-card-quick-btn">
// //             Quick View
// //           </Link>
// //         </div>
// //       </div>
// //       <div className="vanya-card-body">
// //         {catLabel && <p className="vanya-card-category">{catLabel}</p>}
// //         <h4 className="vanya-card-title">{name}</h4>
// //         {priceVal && <p className="vanya-card-price">{priceVal}</p>}
// //       </div>
// //     </div>
// //   );
// // };

// const ProductCard = React.lazy(() => import("../products/Card"));

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function DetailPage() {
//   // ── Router / Cart
//   const { slug } = useParams();
//   const navigate = useNavigate();
//   const { addToCart } = useCart();

//   // ── API State (from DetailPage)
//   const [product, setProduct] = useState(null);
//   const [detail, setDetail] = useState(null);
//   const [variants, setVariants] = useState([]);
//   const [relatedProducts, setRelatedProducts] = useState([]);
//   const [selectedVariant, setSelectedVariant] = useState(null);
//   const [selectedAttributes, setSelectedAttributes] = useState({});
//   const [displayedImages, setDisplayedImages] = useState([]);
//   const [isCartOpen, setIsCartOpen] = useState(false);

//   const [mainImage, setMainImage] = useState(null);
//   const [quantity, setQuantity] = useState(1);
//   const [isWishlisted, setIsWishlisted] = useState(false);

//   const [title, setTitle] = useState("");
//   const [brand, setBrand] = useState({});
//   const [skuCode, setSkuCode] = useState("");
//   const [category, setCategory] = useState({});
//   const [description, setDescription] = useState("");

//   // ── UI State (from Products.jsx)
//   const [activeImage, setActiveImage] = useState(0);
//   const [activeTab, setActiveTab] = useState("description");
//   const [reviewForm, setReviewForm] = useState({
//     name: "",
//     email: "",
//     rating: 5,
//     message: "",
//   });

//   // ── GSAP Refs (from Products.jsx)
//   const mainImgRef = useRef(null);
//   const infoRef = useRef(null);
//   const btnsRef = useRef(null);
//   const relatedRef = useRef(null);
//   const reviewsRef = useRef(null);
//   const breadcrumbRef = useRef(null);
//   const detailsRef = useRef(null);

//   // ─── Fetch Product Detail ─────────────────────────────────────────────────
//   const fetchProductDetail = useCallback(async () => {
//     try {
//       const res = await productAPI.details(slug);

//       if (res.code === 200) {
//         console.log(res.data);
//         const {
//           product,
//           detail,
//           brand,
//           category,
//           variants,
//           relatedProducts,
//           isWishlisted,
//         } = res.data;

//         setProduct(product);
//         setIsWishlisted(isWishlisted || false);
//         setDetail(detail);
//         setBrand(brand);
//         setCategory(category);
//         setVariants(variants || []);
//         setRelatedProducts(relatedProducts || []);
//         setTitle(product?.title);
//         setSkuCode(product?.skuCode);
//         setDescription(detail?.description);

//         // Default variant
//         if (variants?.length > 0) {
//           setSelectedVariant(variants[0]);
//         }

//         // Build image array
//         const images = [];
//         if (product?.thumbnail) images.push(product.thumbnail);
//         if (detail?.images?.length) images.push(...detail.images);
//         if (variants?.length) {
//           variants.forEach((v) => {
//             if (v.images?.length) images.push(...v.images);
//           });
//         }

//         if (images.length > 0) {
//           setDisplayedImages(images);
//           setMainImage(images[0]);
//           setActiveImage(0);
//         }
//       }
//     } catch (err) {
//       console.error("Product fetch error:", err);
//     }
//   }, [slug]);

//   useEffect(() => {
//     fetchProductDetail();
//   }, [fetchProductDetail]);

//   // ─── Build Attribute Map from Variants ───────────────────────────────────
//   const attributeMap = {};
//   variants.forEach((variant) => {
//     if (variant.attributes && typeof variant.attributes === "object") {
//       Object.entries(variant.attributes).forEach(([key, value]) => {
//         if (!attributeMap[key]) attributeMap[key] = new Set();
//         attributeMap[key].add(value);
//       });
//     }
//   });

//   // ─── Pre-select from URL query params ────────────────────────────────────
//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const preSelected = {};
//     for (const [key, value] of params.entries()) {
//       preSelected[key] = value;
//     }

//     if (Object.keys(preSelected).length > 0 && variants.length > 0) {
//       setSelectedAttributes(preSelected);

//       const matched = variants.find((v) =>
//         Object.entries(preSelected).every(
//           ([k, val]) => v.attributes?.[k] === val,
//         ),
//       );

//       if (matched) {
//         setSelectedVariant(matched);
//         setTitle(`${product?.title} - ${matched.variant_name}`);
//         setSkuCode(matched.sku || product?.skuCode);
//         setDescription(matched.description || detail?.description);

//         const variantImgs = matched.images || [];
//         if (variantImgs.length > 0) {
//           setDisplayedImages(variantImgs);
//           setMainImage(variantImgs[0]);
//           setActiveImage(0);
//         }
//       }
//     }
//   }, [variants]);

//   // ─── Variant Click Handler ────────────────────────────────────────────────
//   const handleVariantClick = (key, value) => {
//     const updated = { ...selectedAttributes, [key]: value };
//     setSelectedAttributes(updated);

//     const matched = variants.find((v) =>
//       Object.entries(updated).every(([k, val]) => v.attributes?.[k] === val),
//     );

//     if (matched) {
//       setSelectedVariant(matched);
//       if (matched.images?.length) {
//         setDisplayedImages(matched.images);
//         setMainImage(matched.images[0]);
//         setActiveImage(0);
//       }
//     }
//   };

//   // ─── Image Change (Products.jsx GSAP handler) ────────────────────────────
//   const handleImageChange = (idx) => {
//     if (mainImgRef.current) {
//       gsap.fromTo(
//         mainImgRef.current,
//         { opacity: 0.4, scale: 0.98 },
//         { opacity: 1, scale: 1, duration: 0.4, ease: "power2.out" },
//       );
//     }
//     setActiveImage(idx);
//     setMainImage(displayedImages[idx]);
//   };

//   // ─── Cart Handler ─────────────────────────────────────────────────────────
//   const handleAddToCart = (e) => {
//     const action = e.currentTarget.dataset.action;
//     try {
//       addToCart(product._id, quantity, selectedVariant?._id);
//       if (action === "buy-now") navigate("/checkout");
//     } catch (err) {
//       console.error("Add to cart error:", err);
//     }
//   };

//   // ─── Wishlist Handler ─────────────────────────────────────────────────────
//   const handleWishlistToggle = async (e) => {
//     e.preventDefault();
//     const isLoggedIn = Auth.getToken();
//     if (!isLoggedIn) {
//       showError("Please log in to manage your wishlist");
//       return;
//     }
//     try {
//       const res = await wishlistAPI.addProduct({ productId: product?._id });
//       if (res.code === 200) setIsWishlisted((prev) => !prev);
//     } catch (error) {
//       showError("Failed to update wishlist");
//     }
//   };

//   // ─── YouTube helper ───────────────────────────────────────────────────────
//   const extractYouTubeID = (url) => {
//     const regExp = /(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([^&?/]+)/;
//     const match = url?.match(regExp);
//     return match ? match[1] : null;
//   };

//   // ─── Derived values ───────────────────────────────────────────────────────
//   const price = selectedVariant
//     ? selectedVariant.price
//     : detail?.pricing?.minPrice;

//   const discountPct =
//     selectedVariant?.mrp && selectedVariant.mrp > selectedVariant.price
//       ? Math.round(
//           ((selectedVariant.mrp - selectedVariant.price) /
//             selectedVariant.mrp) *
//             100,
//         )
//       : null;

//   // ─── GSAP Entrance (Products.jsx animations) ─────────────────────────────
//   useEffect(() => {
//     if (!product) return; // wait for data

//     const ctx = gsap.context(() => {
//       const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

//       tl.fromTo(
//         breadcrumbRef.current,
//         { opacity: 0, y: -16 },
//         { opacity: 1, y: 0, duration: 0.5 },
//       )
//         .fromTo(
//           mainImgRef.current,
//           { opacity: 0, scale: 0.96 },
//           { opacity: 1, scale: 1, duration: 0.8 },
//           "-=0.2",
//         )
//         .fromTo(
//           infoRef.current?.querySelectorAll(".gsap-info-child"),
//           { opacity: 0, y: 28 },
//           { opacity: 1, y: 0, stagger: 0.12, duration: 0.6 },
//           "-=0.5",
//         )
//         .fromTo(
//           btnsRef.current,
//           { opacity: 0, y: 20 },
//           { opacity: 1, y: 0, duration: 0.5 },
//           "-=0.2",
//         );

//       // Scroll: Spec rows
//       if (detailsRef.current) {
//         ScrollTrigger.create({
//           trigger: detailsRef.current,
//           start: "top 80%",
//           onEnter: () =>
//             gsap.fromTo(
//               detailsRef.current.querySelectorAll(".gsap-spec-row"),
//               { opacity: 0, x: -20 },
//               {
//                 opacity: 1,
//                 x: 0,
//                 stagger: 0.08,
//                 duration: 0.5,
//                 ease: "power2.out",
//               },
//             ),
//         });
//       }

//       // Scroll: Related products
//       if (relatedRef.current) {
//         ScrollTrigger.create({
//           trigger: relatedRef.current,
//           start: "top 82%",
//           onEnter: () =>
//             gsap.fromTo(
//               relatedRef.current.querySelectorAll(".vanya-product-card"),
//               { opacity: 0, y: 40 },
//               {
//                 opacity: 1,
//                 y: 0,
//                 stagger: 0.12,
//                 duration: 0.6,
//                 ease: "power3.out",
//               },
//             ),
//         });
//       }

//       // Scroll: Reviews
//       if (reviewsRef.current) {
//         ScrollTrigger.create({
//           trigger: reviewsRef.current,
//           start: "top 82%",
//           onEnter: () =>
//             gsap.fromTo(
//               reviewsRef.current.querySelectorAll(".vanya-review-card"),
//               { opacity: 0, y: 30 },
//               {
//                 opacity: 1,
//                 y: 0,
//                 stagger: 0.1,
//                 duration: 0.5,
//                 ease: "power2.out",
//               },
//             ),
//         });
//       }
//     });

//     return () => ctx.revert();
//   }, [product]); // re-run once product loads

//   // ─── Loading ──────────────────────────────────────────────────────────────
//   if (!product) return <div className="container mt-5">Loading...</div>;

//   // ─── JSX ──────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <SEO meta={detail?.meta} />
//         <Breadcrump title={title} />
//       <div className="vanya-pdp">
//         {/* ── Breadcrumb ── */}
//         {/* <div className="container" ref={breadcrumbRef}>
//           <nav className="vanya-breadcrumb">
//             <Link to="/">Home</Link> &nbsp;/&nbsp;
//             <Link to="/shop">Collections</Link> &nbsp;/&nbsp;
//             {category?.name && (
//               <>
//                 <Link to={`/categories/${category?.slug}`}>
//                   {category.name}
//                 </Link>
//                 &nbsp;/&nbsp;
//               </>
//             )}
//             <span>{title}</span>
//           </nav>
//         </div> */}

//         {/* ══════════════════════════════════
//             PRODUCT SHOWCASE
//         ══════════════════════════════════ */}
//         <section className="vanya-section">
//           <div className="container">
//             <div className="row g-5">
//               {/* Left: Gallery */}
//               <div className="col-lg-6">
//                 <div className="vanya-gallery-sticky" ref={mainImgRef}>
//                   <div className="vanya-main-img-wrap">
//                     <img
//                       src={
//                         displayedImages[activeImage] ||
//                         mainImage ||
//                         "/placeholder.jpg"
//                       }
//                       alt={title}
//                       className="vanya-main-img"
//                     />
//                     {product?.badge && (
//                       <span className="vanya-img-badge">{product.badge}</span>
//                     )}
//                   </div>
//                   <div className="vanya-thumb-grid">
//                     {displayedImages.map((img, i) => (
//                       <div
//                         key={i}
//                         className={`vanya-thumb${activeImage === i ? " active" : ""}`}
//                         onClick={() => handleImageChange(i)}
//                       >
//                         <img src={img} alt={`view-${i + 1}`} />
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Right: Info */}
//               <div className="col-lg-6" ref={infoRef}>
//                 {/* Category */}
//                 {category?.name && (
//                   <Link
//                     to={`/categories/${category?.slug}`}
//                     className="text-decoration-none"
//                   >
//                     <p className="vanya-category-label gsap-info-child">
//                       {category.name}
//                     </p>
//                   </Link>
//                 )}

//                 {/* Brand */}
//                 {brand?.name && (
//                   <Link
//                     to={`/brands/${brand?.slug}`}
//                     className="text-decoration-none"
//                   >
//                     <p
//                       className="gsap-info-child"
//                       style={{
//                         fontFamily: "var(--font-subheading)",
//                         fontSize: "0.72rem",
//                         letterSpacing: "0.15em",
//                         textTransform: "uppercase",
//                         color: "var(--color-muted, #888)",
//                         marginBottom: "0.3rem",
//                       }}
//                     >
//                       {brand.name}
//                     </p>
//                   </Link>
//                 )}

//                 {/* Title */}
//                 <h1 className="vanya-product-title gsap-info-child">{title}</h1>

//                 {/* Price */}
//                 <div className="d-flex align-items-center mb-1 gsap-info-child">
//                   {selectedVariant ? (
//                     <>
//                       <span className="vanya-price-current">
//                         ₹{selectedVariant?.price?.toFixed(2)}
//                       </span>
//                       {selectedVariant?.mrp &&
//                         selectedVariant.mrp > selectedVariant.price && (
//                           <>
//                             <span className="vanya-price-original">
//                               ₹{selectedVariant.mrp.toFixed(2)}
//                             </span>
//                             <span className="vanya-price-save">
//                               Save {discountPct}%
//                             </span>
//                           </>
//                         )}
//                     </>
//                   ) : (
//                     <span className="vanya-price-current">
//                       ₹{price?.toLocaleString?.("en-IN") ?? price}
//                     </span>
//                   )}
//                 </div>

//                 {/* Stock status */}
//                 <div className="gsap-info-child mb-2">
//                   {selectedVariant ? (
//                     selectedVariant.stock > 0 ? (
//                       <span
//                         style={{
//                           fontFamily: "var(--font-subheading)",
//                           fontSize: "0.68rem",
//                           letterSpacing: "0.12em",
//                           textTransform: "uppercase",
//                           color: "#2e7d32",
//                         }}
//                       >
//                         ✔ In Stock
//                       </span>
//                     ) : (
//                       <span
//                         style={{
//                           fontFamily: "var(--font-subheading)",
//                           fontSize: "0.68rem",
//                           letterSpacing: "0.12em",
//                           textTransform: "uppercase",
//                           color: "#c0392b",
//                         }}
//                       >
//                         Out of Stock
//                       </span>
//                     )
//                   ) : null}
//                   {/* Hurry-up nudge */}
//                   {selectedVariant &&
//                     selectedVariant.stock > 0 &&
//                     selectedVariant.stock <= 100 && (
//                       <span
//                         style={{
//                           fontFamily: "var(--font-body)",
//                           fontSize: "0.8rem",
//                           color: "#c0392b",
//                           marginLeft: "0.75rem",
//                         }}
//                       >
//                         Only {selectedVariant.stock} left!
//                       </span>
//                     )}
//                 </div>

//                 <hr className="vanya-divider gsap-info-child" />

//                 {/* Short Description */}
//                 {detail?.shortDescription && (
//                   <p
//                     className="gsap-info-child vanya-desc"
//                     style={{
//                       fontFamily: "var(--font-body)",
//                       fontSize: "0.9rem",
//                       lineHeight: "1.85",
//                       color: "var(--color-primary)",
//                       opacity: 0.8,
//                       marginBottom: "1.5rem",
//                     }}
//                   >
//                     {detail.shortDescription}
//                   </p>
//                 )}

//                 {/* Dynamic Variant Attributes */}
//                 {Object.entries(attributeMap).map(([attrKey, values]) => {
//                   const valueArray = [...values];
//                   const label = attrKey
//                     .replace("variantAttribute", "Option ")
//                     .trim();

//                   return (
//                     <div className="mb-3 gsap-info-child" key={attrKey}>
//                       <p className="vanya-option-label">
//                         {label}&nbsp;
//                         <strong
//                           style={{
//                             fontFamily: "var(--font-body)",
//                             fontWeight: 500,
//                             textTransform: "none",
//                             letterSpacing: "0.02em",
//                             color: "var(--color-primary)",
//                           }}
//                         >
//                           {selectedAttributes[attrKey] || "Select"}
//                         </strong>
//                       </p>
//                       <div className="d-flex gap-2 flex-wrap">
//                         {valueArray.map((value, idx) => (
//                           <button
//                             key={idx}
//                             className={`vanya-size-btn${
//                               selectedAttributes[attrKey] === value
//                                 ? " active"
//                                 : ""
//                             }`}
//                             onClick={() => handleVariantClick(attrKey, value)}
//                           >
//                             {value}
//                           </button>
//                         ))}
//                       </div>
//                     </div>
//                   );
//                 })}

//                 <hr className="vanya-divider gsap-info-child" />

//                 {/* Quantity */}
//                 <div className="mb-3 gsap-info-child">
//                   <p className="vanya-option-label">Quantity</p>
//                   <div className="vanya-qty-wrap">
//                     <button
//                       className="vanya-qty-btn"
//                       onClick={() => setQuantity(Math.max(1, quantity - 1))}
//                     >
//                       −
//                     </button>
//                     <span className="vanya-qty-value">{quantity}</span>
//                     <button
//                       className="vanya-qty-btn"
//                       onClick={() => setQuantity(quantity + 1)}
//                     >
//                       +
//                     </button>
//                   </div>
//                 </div>

//                 {/* CTA Buttons */}
//                 <div ref={btnsRef}>
//                   <div className="d-flex gap-2 mb-2">
//                     <button
//                     className="vanya-btn-primary"
//                       onClick={(e) => {
//                         handleAddToCart(e);
//                         setIsCartOpen(true);
//                       }}
//                     >
//                       Add to Cart
//                     </button>
//                     <button
//                       className="vanya-btn-secondary"
//                       data-action="buy-now"
//                       onClick={handleAddToCart}
//                     >
//                       Buy Now
//                     </button>
//                     <button
//                       className={`vanya-btn-wishlist${isWishlisted ? " active" : ""}`}
//                       onClick={handleWishlistToggle}
//                       title={
//                         isWishlisted
//                           ? "Remove from Wishlist"
//                           : "Add to Wishlist"
//                       }
//                     >
//                       {isWishlisted ? "♥" : "♡"}
//                     </button>
//                   </div>

//                   {/* Trust Badges */}
//                   <div className="d-flex flex-wrap gap-3 mt-3">
//                     <span className="vanya-trust-item">
//                       <span className="vanya-trust-icon">✦</span>
//                       Authenticity Guaranteed
//                     </span>
//                     <span className="vanya-trust-item">
//                       <span className="vanya-trust-icon">✦</span>
//                       Free Shipping ₹3000+
//                     </span>
//                     <span className="vanya-trust-item">
//                       <span className="vanya-trust-icon">✦</span>
//                       Easy Returns
//                     </span>
//                   </div>
//                 </div>

//                 {/* Inline Video (if any) */}
//                 {detail?.video && (
//                   <div className="mt-4">
//                     {detail.video.includes("youtube.com") ||
//                     detail.video.includes("youtu.be") ? (
//                       <iframe
//                         width="100%"
//                         height="300"
//                         src={`https://www.youtube.com/embed/${extractYouTubeID(detail.video)}`}
//                         allow="autoplay; encrypted-media"
//                         allowFullScreen
//                         title="Product video"
//                         style={{ border: "none" }}
//                       />
//                     ) : (
//                       <video width="100%" height="300" controls muted>
//                         <source src={detail.video} type="video/mp4" />
//                       </video>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══════════════════════════════════
//             PRODUCT DETAILS + SPECS
//         ══════════════════════════════════ */}
//         <section className="vanya-section-alt" ref={detailsRef}>
//           <div className="container">
//             <div className="row g-5">
//               {/* Key Features Column */}
//               <div className="col-lg-5">
//                 <p className="vanya-category-label">Product Details</p>
//                 <h2 className="vanya-section-heading">Crafted with Purpose</h2>
//                 <div className="vanya-accent-line" />
//                 {detail?.keyFeatures?.length > 0 ? (
//                   detail.keyFeatures.map((feature, index) => (
//                     <div key={index} className="vanya-spec-row gsap-spec-row">
//                       <span className="vanya-spec-label">{feature?.label}</span>
//                       <span className="vanya-spec-value">{feature?.value}</span>
//                     </div>
//                   ))
//                 ) : (
//                   <p
//                     style={{
//                       fontFamily: "var(--font-body)",
//                       fontSize: "0.88rem",
//                       color: "var(--color-muted, #888)",
//                     }}
//                   >
//                     No specifications available.
//                   </p>
//                 )}
//               </div>

//               {/* Tabs Column */}
//               <div className="col-lg-7">
//                 <div className="vanya-tabs">
//                   {["description", "specifications", "shipping"].map((tab) => (
//                     <button
//                       key={tab}
//                       className={`vanya-tab-btn${activeTab === tab ? " active" : ""}`}
//                       onClick={() => setActiveTab(tab)}
//                     >
//                       {tab === "description"
//                         ? "Description"
//                         : tab === "specifications"
//                           ? "Specifications"
//                           : "Shipping & Returns"}
//                     </button>
//                   ))}
//                 </div>

//                 <div className="vanya-tab-content">
//                   {activeTab === "description" &&
//                     (description ? (
//                       <div dangerouslySetInnerHTML={{ __html: description }} />
//                     ) : (
//                       <p>No description available.</p>
//                     ))}

//                   {activeTab === "specifications" &&
//                     (detail?.keyFeatures?.length > 0 ? (
//                       <ul style={{ paddingLeft: "1.2rem", lineHeight: 2 }}>
//                         {detail.keyFeatures.map((feature, i) => (
//                           <li key={i}>
//                             <strong
//                               style={{
//                                 fontFamily: "var(--font-subheading)",
//                                 fontSize: "0.78rem",
//                                 textTransform: "uppercase",
//                                 letterSpacing: "0.1em",
//                               }}
//                             >
//                               {feature?.label}:
//                             </strong>{" "}
//                             {feature?.value}
//                           </li>
//                         ))}
//                         {skuCode && (
//                           <li>
//                             <strong
//                               style={{
//                                 fontFamily: "var(--font-subheading)",
//                                 fontSize: "0.78rem",
//                                 textTransform: "uppercase",
//                                 letterSpacing: "0.1em",
//                               }}
//                             >
//                               SKU:
//                             </strong>{" "}
//                             {skuCode}
//                           </li>
//                         )}
//                       </ul>
//                     ) : (
//                       <p>No specifications available.</p>
//                     ))}

//                   {activeTab === "shipping" && (
//                     <>
//                       <p>
//                         Standard delivery within 5–7 business days across India.
//                         Express delivery available at checkout. International
//                         shipping available to 30+ countries.
//                       </p>
//                       <br />
//                       <p>
//                         Easy 15-day returns on all eligible products. Items must
//                         be in original condition with tags attached. Custom or
//                         altered pieces are not eligible for returns.
//                       </p>
//                       <br />
//                       <p>
//                         All parcels are shipped in our signature gift packaging
//                         — a premium box with tissue wrapping and a handwritten
//                         care card.
//                       </p>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ══════════════════════════════════
//             RELATED PRODUCTS
//         ══════════════════════════════════ */}
//         {relatedProducts.length > 0 && (
//           <section className="vanya-section" ref={relatedRef}>
//             <div className="container">
//               <div className="text-center mb-5">
//                 <p className="vanya-category-label">Curated For You</p>
//                 <h2 className="vanya-section-heading">You May Also Like</h2>
//                 <div className="vanya-accent-line mx-auto" />
//               </div>
//               <div className="row g-4">
//                 {relatedProducts.map(normalizeProduct).map((rp, index) => (
//                   <div key={rp?._id || index} className="col-6 col-md-3">
//                     <ProductCard product={rp} />
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </section>
//         )}

//         {/* ══════════════════════════════════
//             REVIEWS SECTION
//         ══════════════════════════════════ */}
//         <section className="vanya-section-alt" ref={reviewsRef}>
//           <div className="container">
//             {/* Heading + Summary */}
//             <div className="row align-items-start mb-5">
//               <div className="col-lg-3 mb-4 mb-lg-0">
//                 <p className="vanya-category-label">Testimonials</p>
//                 <h2 className="vanya-section-heading">Customer Reviews</h2>
//                 <div className="vanya-accent-line" />
//                 <div className="vanya-rating-big">4.8</div>
//                 <StarRating value={5} />
//                 <p className="vanya-rating-count">124 verified reviews</p>
//               </div>
//               <div className="col-lg-9">
//                 <div className="row g-3">
//                   {REVIEWS.map((r) => (
//                     <div key={r.id} className="col-md-4">
//                       <div className="vanya-review-card h-100">
//                         <div className="d-flex align-items-center justify-content-between">
//                           <span className="vanya-reviewer-name">
//                             {r.name}
//                             {r.verified && (
//                               <span className="vanya-verified">✔ Verified</span>
//                             )}
//                           </span>
//                           <span className="vanya-review-date">{r.date}</span>
//                         </div>
//                         <div className="mt-1">
//                           <StarRating value={r.rating} />
//                         </div>
//                         <p className="vanya-review-text">"{r.text}"</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Review Form */}
//             <div className="row justify-content-center">
//               <div className="col-lg-8">
//                 <div
//                   style={{
//                     borderTop: "1px solid var(--color-border, #ece6dc)",
//                     paddingTop: "3rem",
//                   }}
//                 >
//                   <p className="vanya-category-label text-center">
//                     Share Your Experience
//                   </p>
//                   <h3
//                     className="vanya-section-heading text-center"
//                     style={{ fontSize: "1.5rem" }}
//                   >
//                     Write a Review
//                   </h3>
//                   <div className="vanya-accent-line mx-auto" />

//                   <div className="row g-3">
//                     <div className="col-md-6">
//                       <label className="vanya-form-label">Your Name</label>
//                       <input
//                         className="vanya-form-input"
//                         type="text"
//                         placeholder="Enter your name"
//                         value={reviewForm.name}
//                         onChange={(e) =>
//                           setReviewForm({ ...reviewForm, name: e.target.value })
//                         }
//                       />
//                     </div>
//                     <div className="col-md-6">
//                       <label className="vanya-form-label">Email Address</label>
//                       <input
//                         className="vanya-form-input"
//                         type="email"
//                         placeholder="your@email.com"
//                         value={reviewForm.email}
//                         onChange={(e) =>
//                           setReviewForm({
//                             ...reviewForm,
//                             email: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                     <div className="col-12">
//                       <label className="vanya-form-label">Your Rating</label>
//                       <div>
//                         <StarRating
//                           value={reviewForm.rating}
//                           interactive
//                           onChange={(v) =>
//                             setReviewForm({ ...reviewForm, rating: v })
//                           }
//                         />
//                       </div>
//                     </div>
//                     <div className="col-12">
//                       <label className="vanya-form-label">Your Review</label>
//                       <textarea
//                         className="vanya-form-textarea"
//                         placeholder="Share your thoughts on this piece..."
//                         value={reviewForm.message}
//                         onChange={(e) =>
//                           setReviewForm({
//                             ...reviewForm,
//                             message: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                     <div className="col-12 text-center mt-2">
//                       <button
//                         className="vanya-btn-primary"
//                         style={{ flex: "initial", minWidth: "220px" }}
//                         onClick={() => {
//                           gsap.fromTo(
//                             ".vanya-btn-primary",
//                             { scale: 0.96 },
//                             { scale: 1, duration: 0.25, ease: "back.out(2)" },
//                           );
//                           setReviewForm({
//                             name: "",
//                             email: "",
//                             rating: 5,
//                             message: "",
//                           });
//                         }}
//                       >
//                         Submit Review
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>

//       <CartOffCanvas
//   isOpen={isCartOpen}
//   onClose={() => setIsCartOpen(false)}
// />
//     </>
//   );
// }

import React, { useEffect, useRef, useState, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useCart } from "../../context/CartContext";
import productAPI from "../../api/productApi";
import Breadcrump from "../../components/Breadcrump";
import SEO from "../../components/SEO";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";
import { showError } from "../../utils/toastUtils";
import CartOffCanvas from "../../components/CartOffCanvas";
import { normalizeProduct } from "../../utils/normalizeProduct";

gsap.registerPlugin(ScrollTrigger);

// ─── Static Review Data ──────────────────────────────────────────────────────
const REVIEWS = [
  {
    id: 1,
    name: "Priya Sharma",
    rating: 5,
    date: "March 2025",
    text: "Beautiful craftsmanship and luxurious fabric. The detailing is exceptional.",
    verified: true,
  },
  {
    id: 2,
    name: "Ananya Mehta",
    rating: 5,
    date: "February 2025",
    text: "Wore this to a festive celebration and received countless compliments.",
    verified: true,
  },
  {
    id: 3,
    name: "Kavya Nair",
    rating: 4,
    date: "January 2025",
    text: "Exquisite quality and the packaging was equally luxurious.",
    verified: true,
  },
];

// ─── Star Rating Component ─────────────────────────────────────────────────────
const StarRating = ({ value = 5, max = 5, interactive = false, onChange }) => (
  <span className="d-inline-flex gap-1">
    {Array.from({ length: max }).map((_, i) => (
      <span
        key={i}
        onClick={() => interactive && onChange && onChange(i + 1)}
        style={{
          cursor: interactive ? "pointer" : "default",
          color: i < value ? "var(--color-accent-main)" : "var(--color-border)",
          fontSize: interactive ? "1.4rem" : "1rem",
          lineHeight: 1,
        }}
      >
        ★
      </span>
    ))}
  </span>
);

const ProductCard = React.lazy(() => import("../products/Card"));

export default function DetailPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  // API States
  const [product, setProduct] = useState(null);
  const [detail, setDetail] = useState(null);
  const [variants, setVariants] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState({});
  const [displayedImages, setDisplayedImages] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [isWishlisted, setIsWishlisted] = useState(false);

  // Content States
  const [title, setTitle] = useState("");
  const [brand, setBrand] = useState({});
  const [skuCode, setSkuCode] = useState("");
  const [category, setCategory] = useState({});
  const [description, setDescription] = useState("");
  const [activeTab, setActiveTab] = useState("description");
  const [reviewForm, setReviewForm] = useState({
    name: "",
    email: "",
    rating: 5,
    message: "",
  });

  // Refs
  const mainImgRef = useRef(null);
  const infoRef = useRef(null);
  const btnsRef = useRef(null);
  const relatedRef = useRef(null);
  const reviewsRef = useRef(null);
  const detailsRef = useRef(null);

  const fetchProductDetail = useCallback(async () => {
    try {
      const res = await productAPI.details(slug);
      if (res.code === 200) {
        const {
          product,
          detail,
          brand,
          category,
          variants,
          relatedProducts,
          isWishlisted,
        } = res.data;

        setProduct(product);
        setIsWishlisted(isWishlisted || false);
        setDetail(detail);
        setBrand(brand);
        setCategory(category);
        setVariants(variants || []);
        setRelatedProducts(relatedProducts || []);
        setTitle(product?.title);
        setSkuCode(product?.skuCode);
        setDescription(detail?.description);

        if (variants?.length > 0) setSelectedVariant(variants[0]);

        // Build side-by-side images array
        const imgs = [];
        if (product?.thumbnail) imgs.push(product.thumbnail);
        if (detail?.images?.length) imgs.push(...detail.images);
        setDisplayedImages([...new Set(imgs)]); // Unique images
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }
  }, [slug]);

  useEffect(() => {
    fetchProductDetail();
  }, [fetchProductDetail]);

  const attributeMap = {};
  variants.forEach((v) => {
    if (v.attributes) {
      Object.entries(v.attributes).forEach(([key, value]) => {
        if (!attributeMap[key]) attributeMap[key] = new Set();
        attributeMap[key].add(value);
      });
    }
  });

  const handleVariantClick = (key, value) => {
    const updated = { ...selectedAttributes, [key]: value };
    setSelectedAttributes(updated);
    const matched = variants.find((v) =>
      Object.entries(updated).every(([k, val]) => v.attributes?.[k] === val),
    );
    if (matched) {
      setSelectedVariant(matched);
      if (matched.images?.length) setDisplayedImages(matched.images);
    }
  };

  const handleAddToCart = (e) => {
    const action = e.currentTarget.dataset.action;
    addToCart(product._id, quantity, selectedVariant?._id);
    if (action === "buy-now") navigate("/checkout");
  };

  const handleWishlistToggle = async (e) => {
    e.preventDefault();
    if (!Auth.getToken()) {
      showError("Please log in to manage your wishlist");
      return;
    }
    try {
      const res = await wishlistAPI.addProduct({ productId: product?._id });
      if (res.code === 200) setIsWishlisted((p) => !p);
    } catch (error) {
      showError("Wishlist error");
    }
  };

  const extractYouTubeID = (url) => {
    const match = url?.match(
      /(?:youtube\.com.*(?:\?|&)v=|youtu\.be\/)([^&?/]+)/,
    );
    return match ? match[1] : null;
  };

  useEffect(() => {
    if (!product) return;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        mainImgRef.current,
        { opacity: 0 },
        { opacity: 1, duration: 0.8 },
      );
      gsap.fromTo(
        ".gsap-info-child",
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, stagger: 0.1, duration: 0.6 },
      );
    });
    return () => ctx.revert();
  }, [product]);

  if (!product) return <div className="container mt-5">Loading...</div>;

  const price = selectedVariant
    ? selectedVariant.price
    : detail?.pricing?.minPrice;
  const mrp = selectedVariant ? selectedVariant.mrp : null;
  const discountPct =
    mrp && mrp > price ? Math.round(((mrp - price) / mrp) * 100) : null;

  return (
    <>
      <SEO meta={detail?.meta} />
      <Breadcrump title={title} />

      <div className="vanya-pdp">
        <section className="vanya-section">
          <div className="container">
            <div className="row g-5">
              {/* LEFT: Image Grid (Side by Side) */}
              <div className="col-lg-7">
                <div className="vanya-image-grid" ref={mainImgRef}>
                  {displayedImages.map((img, i) => (
                    <div key={i} className="vanya-grid-item">
                      <img
                        src={img || "/placeholder.jpg"}
                        alt={title}
                        className="vanya-grid-img"
                      />
                      {i === 0 && product?.badge && (
                        <span className="vanya-img-badge">{product.badge}</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* RIGHT: Sticky Information */}
              <div className="col-lg-5">
                <div className="vanya-info-sticky" ref={infoRef}>
                  {category?.name && (
                    <Link
                      to={`/categories/${category?.slug}`}
                      className="text-decoration-none"
                    >
                      <p className="vanya-category-label gsap-info-child">
                        {category.name}
                      </p>
                    </Link>
                  )}

                  {brand?.name && (
                    <Link
                      to={`/brands/${brand?.slug}`}
                      className="text-decoration-none"
                    >
                      <p
                        className="gsap-info-child text-muted text-uppercase mb-1"
                        style={{ fontSize: "0.72rem", letterSpacing: "0.15em" }}
                      >
                        {brand.name}
                      </p>
                    </Link>
                  )}

                  <h1 className="vanya-product-title gsap-info-child">
                    {title}
                  </h1>

                  <div className="d-flex align-items-center mb-1 gsap-info-child">
                    <span className="vanya-price-current">
                      ₹{price?.toFixed(2)}
                    </span>
                    {mrp > price && (
                      <>
                        <span className="vanya-price-original ms-2">
                          ₹{mrp.toFixed(2)}
                        </span>
                        <span className="vanya-price-save ms-2">
                          Save {discountPct}%
                        </span>
                      </>
                    )}
                  </div>

                  <div className="gsap-info-child mb-2">
                    {selectedVariant ? (
                      selectedVariant.stock > 0 ? (
                        <span
                          style={{
                            fontFamily: "var(--font-subheading)",
                            fontSize: "0.68rem",
                            letterSpacing: "0.12em",
                            textTransform: "uppercase",
                            color: "#2e7d32",
                          }}
                        >
                          ✔ In Stock
                        </span>
                      ) : (
                        <span
                          style={{
                            fontFamily: "var(--font-subheading)",
                            fontSize: "0.68rem",
                            letterSpacing: "0.12em",
                            textTransform: "uppercase",
                            color: "#c0392b",
                          }}
                        >
                          Out of Stock
                        </span>
                      )
                    ) : null}
                    {/* Hurry-up nudge */}
                    {selectedVariant &&
                      selectedVariant.stock > 0 &&
                      selectedVariant.stock <= 100 && (
                        <span
                          style={{
                            fontFamily: "var(--font-body)",
                            fontSize: "0.8rem",
                            color: "#c0392b",
                            marginLeft: "0.75rem",
                          }}
                        >
                          Only {selectedVariant.stock} left!
                        </span>
                      )}
                  </div>

                  <hr className="vanya-divider gsap-info-child" />

                  {detail?.shortDescription && (
                    <p
                      className="vanya-desc gsap-info-child mb-4"
                      style={{ fontSize: "0.9rem", opacity: 0.8 }}
                    >
                      {detail.shortDescription}
                    </p>
                  )}

                  {/* Variants */}
                  {Object.entries(attributeMap).map(([attrKey, values]) => (
                    <div className="mb-3 gsap-info-child" key={attrKey}>
                      <p className="vanya-option-label">
                        {attrKey.replace("variantAttribute", "Option ")}:{" "}
                        <strong>{selectedAttributes[attrKey]}</strong>
                      </p>
                      <div className="d-flex gap-2 flex-wrap">
                        {[...values].map((val, idx) => (
                          <button
                            key={idx}
                            className={`vanya-size-btn ${selectedAttributes[attrKey] === val ? "active" : ""}`}
                            onClick={() => handleVariantClick(attrKey, val)}
                          >
                            {val}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}

                  <div className="mb-4 gsap-info-child">
                    <p className="vanya-option-label">Quantity</p>
                    <div className="vanya-qty-wrap">
                      <button
                        className="vanya-qty-btn"
                        onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      >
                        −
                      </button>
                      <span className="vanya-qty-value">{quantity}</span>
                      <button
                        className="vanya-qty-btn"
                        onClick={() => setQuantity(quantity + 1)}
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div ref={btnsRef}>
                    <div className="d-flex gap-2 mb-3">
                      <button
                        className="vanya-btn-primary"
                        onClick={(e) => {
                          handleAddToCart(e);
                          setIsCartOpen(true);
                        }}
                      >
                        Add to Cart
                      </button>
                      <button
                        className="vanya-btn-secondary"
                        data-action="buy-now"
                        onClick={handleAddToCart}
                      >
                        Buy Now
                      </button>
                      <button
                        className={`vanya-btn-wishlist ${isWishlisted ? "active" : ""}`}
                        onClick={handleWishlistToggle}
                      >
                        {isWishlisted ? "♥" : "♡"}
                      </button>
                    </div>

                    <div className="d-flex flex-wrap gap-3 mt-3">
                      <span className="vanya-trust-item">
                        <span className="vanya-trust-icon">✦</span> Authenticity
                        Guaranteed
                      </span>
                      <span className="vanya-trust-item">
                        <span className="vanya-trust-icon">✦</span> Free
                        Shipping ₹3000+
                      </span>
                      <span className="vanya-trust-item">
                        <span className="vanya-trust-icon">✦</span>
                        Easy Returns
                      </span>
                    </div>
                  </div>

                  {detail?.video && (
                    <div className="mt-4 gsap-info-child">
                      {detail.video.includes("youtube.com") ? (
                        <iframe
                          width="100%"
                          height="250"
                          src={`https://www.youtube.com/embed/${extractYouTubeID(detail.video)}`}
                          allowFullScreen
                          style={{ border: "none" }}
                        />
                      ) : (
                        <video width="100%" height="250" controls muted>
                          <source src={detail.video} type="video/mp4" />
                        </video>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TABS SECTION */}
        <section className="vanya-section-alt" ref={detailsRef}>
          <div className="container">
            <div className="row g-5">
              {/* LEFT SIDE */}
              <div className="col-lg-6">
                <p className="vanya-category-label">Product Details</p>
                <h2 className="vanya-section-heading">Crafted with Purpose</h2>
                <div className="vanya-accent-line" />

                {detail?.keyFeatures?.map((f, i) => (
                  <div key={i} className="vanya-spec-row gsap-spec-row">
                    <span className="vanya-spec-label">{f.label}</span>
                    <span className="vanya-spec-value">{f.value}</span>
                  </div>
                ))}
              </div>

              {/* RIGHT SIDE - ONLY DESCRIPTION */}
              <div className="col-lg-6">
                <p className="vanya-category-label">Product Description</p>
                <div className="vanya-description-only">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: description || "No description available.",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* RELATED PRODUCTS */}
        {relatedProducts.length > 0 && (
          <section className="vanya-section" ref={relatedRef}>
            <div className="container">
              <div className="text-center mb-5">
                <h2 className="vanya-section-heading">You May Also Like</h2>
                <div className="vanya-accent-line mx-auto" />
              </div>
              <div className="row g-4">
                {relatedProducts.map(normalizeProduct).map((rp, i) => (
                  <div key={rp._id || i} className="col-6 col-md-3">
                    <ProductCard product={rp} />
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* REVIEWS SECTION */}
        
      </div>

      <CartOffCanvas isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </>
  );
}
